



















































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import TplDetail from "../../../store/entities/tpls/tpl-detail";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import _ from "lodash";
import util from "../../../lib/util";
import AppConsts from "@/lib/appconst";

Vue.use(require("vue-moment"));

@Component({
  components: { "address-modal": AddressModal },
})
export default class UpdateTpl extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  numberRegexPattern = AppConsts.numberRegexPattern;
  addressModalShow: boolean = false;
  tpl: TplDetail = new TplDetail();
  spinShow: boolean = false;
  selectedAddress: Address = new Address();
  tplAddress: Address = null;
  code: string = "";
  get isTpl() {
    return (
      !_.isNil(this.tpl) && !_.isNil(this.tpl.type) && this.tpl.type === "TPL"
    );
  }
  get isVehicle() {
    return (
      !_.isNil(this.tpl) &&
      !_.isNil(this.tpl.type) &&
      this.tpl.type === "VEHICLE"
    );
  }
  updateAddress() {
    if (
      _.isNil(this.tplAddress) ||
      util.addressDiff(this.tplAddress, this.selectedAddress)
    ) {
      this.tpl.contactAddress = this.selectedAddress;
    } else {
      this.tpl.contactAddress = null;
    }
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdateTpl"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "tpl/update",
              data: this.tpl,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.UpdateTpl");
              this.reset();
              this.onGoBack();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "tpl" });
  }
  reset() {
    this.spinShow = false;
    this.addressModalShow = false;
    this.selectedAddress = new Address();
    this.tplAddress = null;
    this.tpl = new TplDetail();
  }
  async getInfo() {
    this.code = this.$root.$router.currentRoute.params.code;
    await this.$store
      .dispatch({
        type: "tpl/get",
        data: {
          id: this.code,
        },
      })
      .then((res) => {
        this.tpl = res;
        this.selectedAddress = this.tpl.contactAddress;
        this.tplAddress = { ...this.tpl.contactAddress };
        this.tpl.contactAddress = null;
      });
  }
  async created() {
    this.spinShow = true;
    try {
      this.reset();
      this.tpl.contactAddress = new Address();
      await this.getInfo();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  rules = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Name")),
      },
    ],
    contactName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ContactName")
        ),
      },
    ],
    contactPhone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ContactPhone")
        ),
      },
    ],
  };
}
